// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BindingExpiration, BindingExpirationSchema } from 'api/gen/BindingExpiration';

const requiredPart = t.interface({
  bindingExpiration: BindingExpirationSchema,
  roleId: t.Integer,
  userProfileAssociationRoleId: t.Integer,
});

export const AssociationRoleManagementSchema = excess(requiredPart);

export interface AssociationRoleManagement extends t.TypeOf<typeof AssociationRoleManagementSchema> {}
